import { format, parse } from "date-fns";

interface Employment {
	startedAt: string;
	endedAt?: string | null;
}

/**
 * Sort a prospect's employments most-recent first (by `startedAt`, descending).
 * Unparseable dates are treated as equal so a bad row can't crash the sort.
 */
export const sortProspectCv = <T extends Employment>(employments?: T[] | null): T[] => {
	const cv = [...(employments ?? [])];

	cv.sort((a, b) => {
		try {
			const aDate = parse(a.startedAt, "yyyy-MM-dd", new Date());
			const bDate = parse(b.startedAt, "yyyy-MM-dd", new Date());

			return aDate > bDate ? -1 : aDate < bDate ? 1 : 0;
		} catch (e) {
			console.error(e);

			return 0;
		}
	});

	return cv;
};

/**
 * Format the current (most-recent) employment as a `"MMM yyyy - MMM yyyy"` range,
 * using `"Present"` for an open-ended role. Expects the CV sorted by
 * {@link sortProspectCv}. Returns `""` when there is no dated current role.
 */
export const formatCurrentEmploymentRange = (sortedCv: Employment[]): string => {
	const current = sortedCv[0];

	if (!current?.startedAt) {
		return "";
	}

	const startDate = format(parse(current.startedAt, "yyyy-MM-dd", new Date()), "MMM yyyy");
	const endDate = current.endedAt
		? format(parse(current.endedAt, "yyyy-MM-dd", new Date()), "MMM yyyy")
		: "Present";

	return `${startDate} - ${endDate}`;
};
